module.exports = __webpack_public_path__ + "img/pu.c29c8221.png";